import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { HelpDialogRecycleComponent } from "../help-dialog-recycle/help-dialog-recycle.component";
import { ActivatedRoute, Router } from '@angular/router';
import { LeadService } from "../services/lead.service";
import { QuestionnaireService } from '../services/questionnaire.service';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent implements OnInit {
  isAnimated: boolean = false;
  
  modalRef: any;
  constructor(private modalService: NgbModal,
     private route: ActivatedRoute, 
    private leadService: LeadService,
    private questionnaireService: QuestionnaireService,
    private router: Router) { }

  ngOnInit() {
    this.leadService.queryObjParams = this.route.snapshot.queryParams;
    setTimeout(() => {
      this.isAnimated = true;
    }, 100);
  }

  naviate(type){
    if(type === "outer") {
      this.questionnaireService.setIsAdvisor(false);
      this.questionnaireService.setCycleType("outer");
      this.router.navigate(["/questionnaire/user-details", 1]);
    } else if(type === "inner") {
      this.questionnaireService.setIsAdvisor(false);
      this.questionnaireService.setCycleType("inner");
      this.modalRef =  this.modalRef = this.modalService.open(HelpDialogRecycleComponent);

} else if(type === "advisor") {
      this.questionnaireService.setIsAdvisor(true);
      //navigate to advisor...
      this.router.navigate(["/questionnaire/advisors", 1]);
    }
  }
  openSite(num) {
		if(num===1){
			window.open("https://www.mizrahi-tefahot.co.il/mortgages/updatemortgage/mortgagerecycling");
		}
		if(num===2){
			window.open("https://www.mizrahi-tefahot.co.il/mortgages/updatemortgage/prime/");
		}
	 }
  
}


// WEBPACK FOOTER //
// ./src/app/start-page/start-page.component.ts